import { render } from "./MacOS.vue?vue&type=template&id=54017e8c&scoped=true"
import script from "./MacOS.vue?vue&type=script&lang=js"
export * from "./MacOS.vue?vue&type=script&lang=js"

import "./MacOS.vue?vue&type=style&index=0&id=54017e8c&scoped=true&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54017e8c"]])

export default __exports__